export enum CoreHeatState {
    OK, OVERHEATED
}
